// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_3KBdPAok5BNsw6xY4-OWjJ","spaceLeft":"afWWdM95yyNycBy51kwOX","spaceBoth":"_2SjHLp4r7EIjq5IS4ImQKY","spaceRight":"_2y6xtct-wUXvsDtcmKHhb7","OasisWidgetFrame":"_2UBKJBPvMotlzjVo7E4JUq","Heading":"_3MWmQQwdzhh6u2whxbvtnA","OasisWidgetContent":"_3DyOoaYzKG-9NHuH7we-Cl","WidgetFloatRightButton":"bQRdkQIgm_PlYo_LZOVKG","OasisWidgetFooter":"DqCN6ZohN8zzh2soX7rP","NoContentPaddingXXS":"_2XTeoS77jJMJUJjxfW8b3v","HeadingText":"_14fpeENBwZXfGvEzq0YBf5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisWidgetFrame.scss
// module id = 141
// module chunks = 0